import type { ImageLoader } from 'next/image';

/** Banner 的服务端提示和可见图片必须使用同一 URL 契约。 */
export const goodsListBannerImageLoader: ImageLoader = ({ src, width, quality }) =>
  `${src}?im=Resize,width=${width},type=downsize&quality=${quality ?? 100}`;
